import { Actions, type SeedListData } from '@openx/types/segments.ts';
import type { Dispatch } from 'react';
import type { Action } from './types.ts';

export const dispatchAddItem = (dispatch: Dispatch<Action>, item: SeedListData) => {
  dispatch({ type: Actions.ADD_ITEM, payload: item });
};
